"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _launcherBase = require("./launcherBase");

/* An input that always sends updates to its parent, and always reflects value prop
 */
var ControlledBlurInput =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(ControlledBlurInput, _React$Component);

  function ControlledBlurInput() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, ControlledBlurInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(ControlledBlurInput)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      focused: false,
      value: ''
    };

    _this.handleKeyPress = function (e) {
      if (e.key === 'Enter' && !_this.props.textarea) {
        if (_this.props.onBlur) {
          _this.props.onBlur(e);
        }

        e.target.blur();
      }

      if (_this.props.onKeyPress) {
        _this.props.onKeyPress(e);
      }
    };

    _this.handleFocus = function (e) {
      // Initialize local value state when the input gains focus.
      if (_this.state.value !== _this.props.value) {
        _this.setState({
          value: _this.props.value
        });
      }

      if (!_this.state.focused) {
        _this.setState({
          focused: true
        });
      }

      if (_this.props.onFocus) {
        _this.props.onFocus(e);
      }
    };

    _this.handleBlur = function (e) {
      if (_this.state.focused) {
        _this.setState({
          focused: false
        });
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(e);
      }
    };

    _this.onChange = function (e) {
      // Keep track of value changes locally.
      if (_this.state.value !== e.target.value) {
        _this.setState({
          value: e.target.value
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange(e);
      }
    };

    _this.forceInputBlur = function () {
      // check to see if DOM value differs from React state value
      // only trigger handleBlur when input does NOT have focus
      if (!_this.input || _this._previousValue === _this.input.value || _this.input === document.activeElement) {
        return;
      }

      _this._previousValue = _this.input.value; // manually trigger input event

      var evt = document.createEvent('HTMLEvents');
      evt.initEvent('input', true, true);

      _this.input.dispatchEvent(evt);

      _this.handleBlur(evt);
    };

    _this.refInput = function (input) {
      _this.input = input;

      if (_this.props.onSetInput) {
        _this.props.onSetInput(input);
      }
    };

    return _this;
  }

  (0, _createClass2["default"])(ControlledBlurInput, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this._listener);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var autoComplete = this.props.autoComplete;
      var isAutoCompleteOff = /^(false|off)$/.test(autoComplete); // input change workaround for browser autofill should be
      // triggered only if autoComplete is specified and is
      // something other than 'false', 'off'.

      if (autoComplete && !isAutoCompleteOff) {
        (0, _launcherBase.callAfterNextAnimationFrame)(this.forceInputBlur);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          textarea = _this$props.textarea,
          onSetInput = _this$props.onSetInput,
          controlledEditing = _this$props.controlledEditing,
          _this$props$autoCompl = _this$props.autoComplete,
          autoComplete = _this$props$autoCompl === void 0 ? 'off' : _this$props$autoCompl,
          otherProps = (0, _objectWithoutProperties2["default"])(_this$props, ["textarea", "onSetInput", "controlledEditing", "autoComplete"]); // We do not want to reflect the value prop while the input has focus;
      // use the local state value unless controlledEditing is enabled.

      var value = this.props.value;

      if (this.state.focused && !this.props.controlledEditing) {
        value = this.state.value;
      } // The value prop must always have a value, otherwise it switches this to
      // an uncontrolled input.


      if (typeof value === 'undefined' || value === null) {
        value = '';
      }

      var props = (0, _objectSpread2["default"])({}, otherProps, {
        autoComplete: autoComplete,
        value: value,
        ref: this.refInput,
        onKeyPress: this.handleKeyPress,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onChange: this.onChange
      });

      if (textarea) {
        return _react["default"].createElement("textarea", props);
      }

      return _react["default"].createElement("input", (0, _extends2["default"])({
        type: "text"
      }, props));
    }
  }]);
  return ControlledBlurInput;
}(_react["default"].Component);

exports["default"] = ControlledBlurInput;
ControlledBlurInput.propTypes = process.env.NODE_ENV !== "production" ? {
  id: _propTypes["default"].string,
  onChange: _propTypes["default"].func.isRequired,
  onKeyPress: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onSetInput: _propTypes["default"].func,
  controlledEditing: _propTypes["default"].bool,
  value: _propTypes["default"].string,
  textarea: _propTypes["default"].bool,
  placeholder: _propTypes["default"].string,
  autoComplete: _propTypes["default"].string
} : {};


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/util/ControlledBlurInput.js
// module id = 198
// module chunks = 0